import { ISymbolData } from '../parseToTree.types';
import { IMergeTagsInListOptions } from './mergeTagsInList.types';

export const mergeTagsInList = ({
  symbolsPositions,
}: IMergeTagsInListOptions): Record<number, ISymbolData> => {
  const symbols = Object.keys(symbolsPositions);
  const listOfTags: Record<number, ISymbolData> = {};

  for (let i = 0; i < symbols.length; i++) {
    const symbol = symbols[i];
    const tagsData = symbolsPositions[symbol];

    for (let j = 0; j < tagsData.length; j++) {
      const tagData = tagsData[j];

      listOfTags[tagData.start] = {
        ...tagData,
        tag: symbol,
      };
    }
  }

  return listOfTags;
};
